"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.withBrowserRouter = void 0;
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const container_1 = require("./container");
const utils_1 = require("./utils");
const Router = (props) => {
    const routes = props.routes || (0, container_1.getRouterConfigs)();
    const location = (0, react_router_dom_1.useLocation)();
    (0, react_1.useEffect)(() => {
        window.scrollTo(0, 0);
    }, [location]);
    return (0, react_router_dom_1.useRoutes)((0, utils_1.createRoutes)(routes), location);
};
const withBrowserRouter = (Component) => (props) => (react_1.default.createElement(react_router_dom_1.BrowserRouter, null,
    react_1.default.createElement(Component, Object.assign({}, props))));
exports.withBrowserRouter = withBrowserRouter;
exports.default = Router;
//# sourceMappingURL=router.js.map